import { useLayoutEffect } from 'react';

const RESIZE_DEBOUNCE_MS = 100;

export function useContainerHeightVar(ref) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;

    const applyHeight = () => {
      const { height } = el.getBoundingClientRect();
      if (height > 0) {
        el.style.setProperty('--freeAnswer-h', `${height}px`);
      }
    };
    applyHeight();

    let debounceTimer = null;
    const observer = new ResizeObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(applyHeight, RESIZE_DEBOUNCE_MS);
    });
    observer.observe(el);

    return () => {
      clearTimeout(debounceTimer);
      observer.disconnect();
    };
  }, [ref]);
}
